import { toNumber } from 'lodash'
import './Price.sass'

function Price({ num, stroked, highlighted }) {
  return (
    <span className={`${stroked && 'Stroked'} ${highlighted && 'Highlighted'}`}>
      {toNumber(num).toLocaleString('uk-UA', {
        // style: 'currency',
        currency: 'UAH',
      })}{' '}
      ₴
    </span>
  )
}

export default Price
